import type * as React from 'react';
import { EmptyState, TodayLayout } from '@redhand/ui';

/** Vzorova obrazovka: prvni den tenanta — vsechno prazdne, nic nesmi vypadat rozbite. */
export function PrazdnyStartSample(): React.JSX.Element {
  return (
    <TodayLayout
      title="Vítej v systému"
      date="Tvůj účet je připravený — začni prvním krokem."
      aside={
        <div className="rh-card">
          <EmptyState
            icon={<span>📬</span>}
            title="Žádné poptávky"
            description="Poptávky z webu se sem začnou sbírat automaticky, jakmile připojíš formulář."
          />
        </div>
      }
    >
      <div className="rh-card">
        <EmptyState
          icon={<span>🏠</span>}
          title="Zatím tu nic není — a to je v pořádku"
          description="Systém se naplní prvním náběrem. Průvodce tě provede adresou, parametry, fotkami a přípravou inzerátu. Nic z toho nejde ztratit — všechno se průběžně ukládá."
          action={<button type="button" className="rh-btn rh-btn--primary">Nabrat první nemovitost</button>}
        />
      </div>
    </TodayLayout>
  );
}
